<template>
  <!-- class="sidebar sidebar-right" -->
  <div
    class=""
    :class="
      global.showSidebar === true ? 'pace-done pace-done aside-right-open' : ''
    "
  >
    <aside class="sidebar sidebar-right">
      <!-- class="sidebar-content" -->
      <div class="sidebar-content">
        <!--  -->
        <button type="button" class="close-btn" @click="closeSidebar()">
          <span aria-hidden="true"
            ><i class="icon dripicons-cross myclose"></i
          ></span>
        </button>

        <!-- 導航?�目 -->
        <div class="row col-12 mx-auto px-0 mb-3 nav-grid">
          <div
            v-for="item in allNavItems"
            :key="item.path"
            class="col-6 col-md-3 nav-grid-item pointer border px-0 mx-0 d-flex justify-content-center"
            @click="handleNavItemClick(item)"
          >
            <div
              class="d-flex flex-column align-items-center justify-content-center func-height"
            >
              <i
                :class="[
                  item.icon,
                  'icon text-center header-text',
                  global.lightHeaderText === item.tag ? 'text-primary' : '',
                ]"
              ></i>
              <div
                class="text-center m-text msu-semibold header-text mt-1"
                :class="
                  global.lightHeaderText === item.tag ? 'text-primary' : ''
                "
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Access (B2C ?�戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-2 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("Quick Access") }}
          </h6>
          <div class="activity-row">
            <div
              v-for="item in userCardBtnItems"
              :key="item.title"
              class="activity-item"
              @click="goSiteAndHide(item.link)"
            >
              <img
                :src="getButtonImage(item.imageType)"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>

        <!-- ?��?�?-->
        <hr
          v-if="userCustomization.userGroup === 'B2C'"
          class="sidebar-divider"
        />

        <!-- English 活�? (B2C ?�戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("English") }}
          </h6>
          <div class="activity-row">
            <div
              v-for="i in userCardActivities.english.items"
              :key="`sidebar-english-${i}`"
              class="activity-item"
              @click="goExternalLink(i, 'english')"
            >
              <img
                :src="getActivityImage(i, 'english')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>

        <!-- ?��?�?-->
        <hr
          v-if="userCustomization.userGroup === 'B2C'"
          class="sidebar-divider"
        />

        <!-- Relax 活�? (B2C ?�戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("Relax") }}
          </h6>
          <div class="activity-row">
            <div
              v-for="i in userCardActivities.relax.items"
              :key="`sidebar-relax-${i}`"
              class="activity-item"
              @click="goExternalLink(i, 'relax')"
            >
              <img
                :src="getActivityImage(i, 'relax')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>

        <!--  -->
      </div>
    </aside>
  </div>
</template>
<script setup>
import { ApiGetHomeFunc } from "@/service/apis/learnInfo";
import { useI18n } from "vue-i18n";
import { useGlobalStore } from "@/store/modules/global";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
import { useUserInfoStore } from "@/store/modules/userInfo";

const { locale, t } = useI18n({
  inheritLocale: true,
});

const global = useGlobalStore();
const userCustomization = useUserCustomizationStore();
const user = useUserInfoStore();

const langList = computed(() => {
  return global.langList;
});
const changeLang = (lang) => {
  if (locale.value !== lang) {
    locale.value = lang;
    // i18n.global.locale.value = lang;
    localStorage.setItem("locale", locale.value);
    window.location.reload();
  }
};
const closeSidebar = () => {
  global.$patch((state) => {
    state.showSidebar = false;
  });
};
const openNotify = () => {
  $(`#modal-notify`).modal("show");
};
// const changeLightHeaderText = (text) => {
//   global.$patch((state) => {
//     state.lightHeaderText = text;
//   });
// };
const $goPage = inject("$goPage");

// 使用客製?��?置�?導航?�目
const navItem = computed(() => {
  const filteredNavItems = userCustomization.filteredNavItems;

  // 將�?置�??�為組件?�要�??��?
  return filteredNavItems.map((item) => ({
    path: item.path,
    name: t(item.name),
    icon:
      item.icon === "dripicons-home"
        ? "fas fa-house"
        : item.icon === "dripicons-graduation"
        ? "fas fa-graduation-cap"
        : item.icon === "fa-solid fa-robot"
        ? "fas fa-robot"
        : item.icon === "dripicons-trophy"
        ? "fas fa-trophy"
        : item.icon === "dripicons-calendar"
        ? "fas fa-calendar"
        : "fas fa-house",
    tag: item.tag,
  }));
});

// ?�?��??��??��??�含 Notify）�?一????
const allNavItems = computed(() => {
  const allItems = [...navItem.value];

  // 添�? Notify ?�鍵?��??��??�中
  allItems.push({
    path: "#notify",
    name: t("Notify"),
    icon: "fa-regular fa-bell",
    tag: "notify",
  });

  return allItems;
});

// UserCard ?��??�能
const userCardBtnItems = computed(() => {
  return userCustomization.filteredUserCardBtnItems.map((item) => ({
    ...item,
    title: t(item.title),
  }));
});

const userCardActivities = computed(() => {
  const activities = userCustomization.userCardActivities;
  if (activities && activities.english && activities.relax) {
    return activities;
  }
  return {
    english: { items: [] },
    relax: { items: [] },
  };
});

// ?��??��??��?
const getButtonImage = (buttonType) => {
  return new URL(
    `../assets/img/activity_icon/functionimg/${buttonType}.png`,
    import.meta.url
  ).href;
};

// ?��?活�??��?
const getActivityImage = (index, activityType) => {
  if (activityType === "english") {
    return new URL(`../assets/img/activity_icon/e${index}.png`, import.meta.url)
      .href;
  } else if (activityType === "relax") {
    return new URL(
      `../assets/img/activity_icon/game${index}.png`,
      import.meta.url
    ).href;
  }
};

// ?��??�示??
const getHintValue = (hintType) => {
  if (hintType === "totalReward") {
    return user.hint.totalReward;
  }
  return "";
};

// 外部???跳�?
const goExternalLink = (index, activityType) => {
  const currentLang = locale.value;
  if (activityType === "english") {
    if (index === 1) {
      $goPage(`/msu/phrasal-verb?LANG=${currentLang}`);
    } else if (index === 2) {
      $goPage(`/msu/daily-conversation?LANG=${currentLang}`);
    } else if (index === 4) {
      let token = localStorage.getItem("token");
      let link = `https://ai-edu.mangosteems.com/ai_speak/?lang=${currentLang}&auth=${token}?userid=${user.student.stuID}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      $goPage(`/msu/practice-words`);
    } else if (index === 5) {
      $goPage(`/msu/english-central`);
    }
  } else if (activityType === "relax") {
    if (index === 1) {
      // ?��? index 1 ?��?�?
    } else if (index === 2) {
      let token = localStorage.getItem("token");
      let link = `https://whacamole.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      let token = localStorage.getItem("token");
      let link = `https://cardgame.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    }
  }
  closeSidebar();
};

const handleNavItemClick = (item) => {
  if (item.path === "#notify") {
    openNotify();
  } else {
    goSiteAndHide(item.path);
  }
};
const getHomeFunc = async () => {
  let result = await ApiGetHomeFunc.get();
  // console.log(result);
};
const goSiteAndHide = (path) => {
  $goPage(path);
  closeSidebar();
};
onMounted(() => {
  console.log("home side bar");
  getHomeFunc();
});
</script>
<style lang="scss" scoped>
.func-height {
  width: 100%;
  aspect-ratio: 1 / 1; // ?��??�現等�?�?���?
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0; // 移除padding，让大小一致
  height: 100%; // 填满父容器
  min-height: auto;
}

.nav-grid {
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0; // 移除空白
}

.nav-grid-item {
  padding: 0; // 移除padding，让大小一致
  flex: 0 0 25%; // PC/平板：4个一排，每个占25%，无空白
  max-width: 25%;
  border: none !important; // 移除边框
  background: transparent;
  aspect-ratio: 1 / 1; // 确保是正方形
  display: flex; // 确保flex布局生效
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(50, 193, 219, 0.05); // 悬停时浅色背景
  }
}

// 平板设备（768px - 992px）
@media (max-width: 992px) and (min-width: 577px) {
  .nav-grid {
    max-width: 100%;
    gap: 0; // 移除空白
  }

  .nav-grid-item {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

// 手机设备（576px以下）：2x2正方形布局
@media (max-width: 576px) {
  .nav-grid {
    max-width: 220px;
    gap: 0; // 移除空白
  }

  .nav-grid-item {
    flex: 0 0 50%; // 手机：2个一排，每个占50%，无空白
    max-width: 50%;
    padding: 0; // 移除padding，让大小一致
    border: 1px solid #e5e7eb !important; // 手机端添加格线
    border-radius: 0; // 移除圆角，让边框紧贴
    aspect-ratio: 1 / 1; // 确保是正方形
  }

  // 为手机端的第一个和第三个项目添加左上和左下圆角
  .nav-grid-item:nth-child(1) {
    border-top-left-radius: 8px;
  }

  .nav-grid-item:nth-child(2) {
    border-top-right-radius: 8px;
  }

  .nav-grid-item:nth-child(3) {
    border-bottom-left-radius: 8px;
  }

  .nav-grid-item:nth-child(4) {
    border-bottom-right-radius: 8px;
  }

  .func-height {
    padding: 6px;
  }
}

.header-text {
  color: #4d5a68; // 默认灰色文字
  transition: color 0.2s ease;
}

.header-text:hover {
  color: #4d5a68 !important; // 悬停时保持灰色
}

.text-primary {
  color: #32c1db !important; // 选中时显示蓝色
}

//
div.aside-right-open .sidebar-right {
  box-shadow: 0 0 15px 1px rgb(69 65 78 / 20%);
  right: 0;
  overflow-y: auto; // ?�許?�直滾�?
  overflow-x: hidden; // ?��?水平滾�?
  display: block;
}
//

.sidebar-right {
  order: 3;
  z-index: 1005;
  position: fixed;
  overflow-y: auto; // 添�??�直滾�?
  overflow-x: hidden; // ?��?水平滾�?
  width: 580px !important; // 增�?寬度
  right: -760px;
  padding: 18px;
  background-color: #fff;

  // ?��?式設�?- 小螢幕適??
  @media (max-width: 1200px) {
    width: 580px !important;
    right: -690px;
    padding: 16px;
  }

  @media (max-width: 992px) {
    width: 500px !important;
    right: -620px;
    padding: 14px;
    overflow-y: auto; // 確�??��???92px?�可以滾??
    max-height: 100vh; // ?�制?�大�?度為視�?高度
  }

  @media (max-width: 768px) {
    width: 380px !important;
    right: -520px;
    padding: 8px;
    overflow-y: auto; // 確�??��???68px?�可以滾??
    max-height: 100vh; // ?�制?�大�?度為視�?高度
  }

  @media (max-width: 576px) {
    width: 320px !important;
    right: -450px;
    padding: 12px;
    overflow-y: auto; // 確�??��???76px?�可以滾??
    max-height: 100vh; // ?�制?�大�?度為視�?高度
  }

  @media (max-width: 480px) {
    width: 290px !important;
    right: -410px;
    padding: 10px;
    overflow-y: auto; // 確�??��???80px?�可以滾??
    max-height: 100vh; // ?�制?�大�?度為視�?高度
  }
}

.customizer-panel-wrapper,
.sidebar-right {
  display: block !important;
  top: 0;
  bottom: 0;
  backface-visibility: hidden;
  transition: all 0.3s ease;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.myclose {
  font-size: 40px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 576px) {
    font-size: 28px;
  }
}

// 活動區塊排版（手機預設為 2x2）
.activity-row {
  margin: 0 auto 1.25rem;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(110px, 1fr));
  gap: 0; // 移除gap，只靠padding控制间距
  max-width: 250px;
  width: 100%; // 确保宽度填满容器
  justify-content: center; // 确保内容居中
}

.activity-item {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  padding: 2px; // 减少padding，缩小图片间距
  // border-radius: 12px;
  // background-color: #fff;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
}

// 活動按鈕圖片樣式
.activity-btn-img {
  width: 85%; // 缩小图片尺寸
  height: 85%; // 缩小图片尺寸
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 10px; // 添�??��?
}

@media (min-width: 768px) {
  .activity-row {
    grid-template-columns: repeat(4, minmax(110px, 1fr));
    max-width: 100%;
    gap: 0; // 移除gap，只靠padding控制间距
  }
}

.activity-btn-img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); // 添�??�影?��?
}

// 導航?�目?��?�?? - 統�?大�?
.icon {
  font-size: 2rem !important; /* 統�??��?大�? - ?�大 */
  width: 55px; // 統�?寬度 - ?�大
  height: 55px; // 統�?高度 - ?�大
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px; // 添�??��?
  background-color: transparent; // 移除背景色 // 添�??�景??
  transition: all 0.2s ease;
  color: #788db4; // 默认图标颜色
}

.icon:hover {
  transform: scale(1.05);
  color: #788db4; // 悬停时保持图标颜色
}

// 选中状态的图标颜色
.nav-grid-item .icon.text-primary {
  color: #32c1db !important; // 选中时显示蓝色
}

@media (max-width: 768px) {
  .icon {
    font-size: 1.65rem !important;
    width: 60px; // 小螢幕�?調整大�?
    height: 60px;
  }

  .activity-btn-img {
    width: 80px; // 缩小平板图片尺寸 // 平板?��?機�?調整
    height: 80px;
  }

  .func-height {
    min-height: 80px; // 小螢幕�?調整高度
    padding: 8px; // 調整?��?�?
  }
}

@media (max-width: 576px) {
  .icon {
    font-size: 1.35rem !important;
    width: 52px; // ?��??��??�調?�大�?
    height: 52px;
  }

  .activity-btn-img {
    width: 90px; // 缩小手机图片尺寸 // ?��???
    height: 90px;
  }

  .func-height {
    min-height: 75px; // ?��??��??�調?��?�?
    padding: 6px; // 調整?��?�?
  }
}

// ?��?式�?字大�?
.m-text {
  font-size: 1rem !important; // 增�??��??��?大�?

  @media (max-width: 768px) {
    font-size: 0.95rem !important;
  }

  @media (max-width: 576px) {
    font-size: 0.85rem !important;
  }
}

// 確�??�容?��??��?上�??�溢??
.sidebar-content {
  position: relative;
  padding-top: 60px; // 为关闭按钮留出足够空间，确保导航图标在关闭按钮下方

  @media (max-width: 768px) {
    padding-top: 62px;
    padding-left: 5px;
    padding-right: 5px;
  }

  @media (max-width: 576px) {
    padding-top: 58px;
    padding-left: 2px;
    padding-right: 2px;
  }
}

// 活�?標�?顏色
.activity-title-color {
  color: #4a5568; // 更深的灰色
  font-weight: 600;
  margin-bottom: 12px;
  font-size: 1.1rem !important; // 增�?標�?字�?大�?

  @media (max-width: 768px) {
    font-size: 1rem !important;
  }

  @media (max-width: 576px) {
    font-size: 0.95rem !important;
  }
}

// 行動裝置活動區塊排列
.activity-row {
  margin: 0 auto 1.25rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(110px, 1fr));
  gap: 0; // 移除gap，只靠padding控制间距
  max-width: 250px;
  width: 100%; // 确保宽度填满容器
  justify-content: center; // 确保内容居中
}

.activity-item {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  padding: 2px; // 减少padding，缩小图片间距
  border-radius: 12px;
  // background-color: #fff;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
}

.activity-btn-img {
  width: 84%; // 缩小图片尺寸
  height: 84%; // 缩小图片尺寸
  object-fit: contain;
}

@media (min-width: 768px) {
  .activity-row {
    grid-template-columns: repeat(4, minmax(110px, 1fr));
    max-width: 100%;
    gap: 0; // 移除gap，只靠padding控制间距
  }
}

// ?��?線樣�?
.sidebar-divider {
  border: none;
  border-top: 1px solid #e5e7eb; // 更细的分隔线
  margin: 1.25rem 0;

  @media (max-width: 768px) {
    margin: 1.25rem 0;
  }

  @media (max-width: 576px) {
    margin: 1rem 0;
  }
}

// ?�右?��?欄添?�自定義滾�?條樣�?
.sidebar-right::-webkit-scrollbar {
  width: 6px;
}

.sidebar-right::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.sidebar-right::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
</style>
